import { OrderStatusType, ServiceType } from 'types/order.types'

type FreightType = 'ltl' | 'tl'

export const ORDER_STATUS_LABELS_MAP: Record<OrderStatusType, string> = {
    quoting: 'Quoting',
    procuring: 'Procuring',
    scheduled: 'Scheduled',
    inTransit: 'In transit',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    onHold: 'On hold',
    quoteLost: 'Quote lost',
} as const

export const ORDER_STATUS_OPTIONS = Object.entries(ORDER_STATUS_LABELS_MAP).map(
    ([value, label]) => ({
        value,
        label,
    })
) as { value: OrderStatusType; label: string }[]

export const ORDER_COMMODITY_TYPE_LONG_LABELS: {
    [key in FreightType]: string
} = {
    ltl: 'Less than truckload',
    tl: 'Truckload',
}

export const SERVICE_TYPE_LABELS: {
    [key in ServiceType]: string
} = {
    tl: 'TL',
    ltl: 'LTL',
}

export const SERVICE_TYPE_OPTIONS = Object.keys(SERVICE_TYPE_LABELS).map(
    (key) => ({
        value: key as ServiceType,
        label: SERVICE_TYPE_LABELS[key as ServiceType],
    })
)
